import { createAction, props } from "@ngrx/store";
import { ICapability } from "@skills-app/models/capability";
import { ILead } from "@skills-app/models/capabilityLead";
import { ISkillGroup } from "@skills-app/models/skillGroup";
import { ThingSpaceType } from "@skills-app/models/thingspaceGraph";

const prefix = "[Capabilities Page]";

export const requestAddCapabilityLeads = createAction(
  `${prefix} Add Capability Leads`,
  props<{ capabilities: ICapability[] }>(),
);

export const requestCapabilities = createAction(`${prefix} Get Capabilities`);

export const populateCapabilities = createAction(
  `${prefix} Populate Capabilities`,
  props<{ capabilities: ICapability[] }>(),
);

export const filterConsultants = createAction(
  `${prefix} Filter Consultants`,
  props<{ namePrefix: string }>(),
);

export const populateFilterResults = createAction(
  `${prefix} Populate Consultants`,
  props<{ consultants: ILead[] }>(),
);

export const requestRemoveCapabilityLead = createAction(
  `${prefix} Remove Capability Lead`,
  props<{ capabilityId: ThingSpaceType }>(),
);

export const getCapabilitySuccess = createAction(
  `${prefix} Get Capability Success`,
  props<{ capability: ICapability }>(),
);

export const getCapabilityFailure = createAction(
  `${prefix} Get Capability Failure`,
);

export const getSkillGroupsForSelectedCapabilityRequest = createAction(
  `${prefix} Get Skill Groups For Selected Capability`,
  props<{ capability: ICapability }>(),
);

export const getSkillGroupsForSelectedCapabilitySuccess = createAction(
  `${prefix} Get Skill Groups For Selected Capability Success`,
  props<{ skillGroups: ISkillGroup[] }>(),
);

export const getSkillGroupsForSelectedCapabilityFailure = createAction(
  `${prefix} Get Skill Groups For Selected Capability Failure`,
);
